(function () {
	'use strict';

	angular
		.module('app.setup')
    .service('sqlSnippetService', sqlSnippetService);

	sqlSnippetService.$inject = ['$http', 'URLS'];
  
	function sqlSnippetService($http, URLS) {
		return {
			getSnippets: getSnippets
		};
    
		function getSnippets(companyId, type) {
			var pageUrl = String.format(URLS.getSqlSnippetsByType, companyId, type);
			return $http.get(URLS.host + pageUrl)
        .then(getSnippetsSuccess)
        .catch(getSnippetsFailed);
      
			function getSnippetsSuccess(response) {
				return response.data;
			}

			function getSnippetsFailed(error) {
				return [];
			}
		}
	}
})();